import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { routes } from 'flow/types/routes';
import { useHistory } from 'react-router-dom';
import { extractName } from 'flow/utils';
import { fetchContact, fetchEditableContact } from 'flow/actions/contact-actions';
import { getIsSinglePaneMode } from 'flow/selectors/selectors';
import { selectExtensions } from 'flow/selectors/ExtensionSelectors';
import Page from 'flow/components/Setting/Page';
import ContactHeader from 'flow/components/contact-card/ContactHeader';
import ContactInfoCard from 'flow/components/contact-card/ContactInfoCard';
import ContactSettingsCard from 'flow/components/contact-card/ContactSettingsCard';
import ContactScheduleCard from 'flow/components/contact-card/ContactScheduleCard';
import { createSelector } from 'reselect';
import ContactCallHistoryWidgetTW from 'flow/components/contact-card/ContactCallHistoryWidgetTW';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ContactView = function ContactView(_ref) {
  var _history$location$sta;
  var onNavigation = _ref.onNavigation,
    contact = _ref.contact,
    calendarPath = _ref.calendarPath;
  var dispatch = useAppDispatch();
  var history = useHistory();
  var contactKey = contact === null || contact === void 0 ? void 0 : contact.get('key');
  var isSinglePaneMode = useAppSelector(getIsSinglePaneMode);
  var extensionKey = useAppSelector(function (state) {
    return selectExtensionKeyFromContactKey(state, contactKey);
  });
  useEffect(function () {
    if (contactKey) {
      dispatch(fetchContact(contactKey));
      dispatch(fetchEditableContact(contactKey));
    }
  }, [dispatch, contactKey]);
  var propsWithKeys = {
    contactKey: contactKey,
    extensionKey: extensionKey,
    contact: contact,
    onNavigation: onNavigation
  };
  return /*#__PURE__*/_jsx(Page, {
    childrenClassName: "w-full",
    header: extractName(contact),
    onClickBack: (_history$location$sta = history.location.state) !== null && _history$location$sta !== void 0 && _history$location$sta.from ? function () {
      var _history$location$sta2;
      return history.push((_history$location$sta2 = history.location.state) === null || _history$location$sta2 === void 0 ? void 0 : _history$location$sta2.from);
    } : isSinglePaneMode ? function () {
      return history.push(routes['tickets']);
    } : undefined,
    discardHeader: true,
    useContactCardStyles: true,
    children: /*#__PURE__*/_jsx("div", {
      className: "flex flex-col items-center",
      children: /*#__PURE__*/_jsxs("div", {
        className: "@container relative flex w-full max-w-screen-md flex-col gap-y-6",
        children: [/*#__PURE__*/_jsx(ContactHeader, _objectSpread({}, propsWithKeys)), /*#__PURE__*/_jsxs("div", {
          className: "flex flex-col items-start gap-6 @2xl:flex-row",
          children: [/*#__PURE__*/_jsx(ContactInfoCard, _objectSpread({}, propsWithKeys)), /*#__PURE__*/_jsxs("div", {
            className: "flex w-full min-w-1/2 flex-col gap-6 @2xl:w-auto",
            children: [/*#__PURE__*/_jsx(ContactSettingsCard, _objectSpread({}, propsWithKeys)), /*#__PURE__*/_jsx(ContactScheduleCard, _objectSpread(_objectSpread({}, propsWithKeys), {}, {
              calendarPath: calendarPath
            })), /*#__PURE__*/_jsx(ContactCallHistoryWidgetTW, _objectSpread({}, propsWithKeys))]
          })]
        })]
      })
    })
  });
};
export default /*#__PURE__*/React.memo(ContactView);
var selectExtensionKeyFromContactKey = createSelector([selectExtensions, function (_state, contactKey) {
  return contactKey;
}], function (extensions, contactKey) {
  if (!contactKey) return null;
  var extension = extensions.find(function (extension) {
    return extension.getIn(['contact', 'key']) === contactKey;
  });
  return extension === null || extension === void 0 ? void 0 : extension.get('key');
});